import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { CLRxableSelect } from "./CLRxableSelect.js";
import { useCLEcommContext } from "../../../../../../../../../../../context/modules/EcommContent/ContactLensesEcommContent/context/CLEcommContext.js";
import { WITH_RX, WITHOUT_RX } from "../../../../../../../../../../../../components/RxableSelect/modules/EcommContent/components/RxableSelect/contants.js";
const CLRxableSelectContainer = ({ className }) => {
  const { getLabel } = useIntl();
  const { actions, state } = useCLEcommContext();
  const { rxToggle } = state.configurations;
  const radioButtonItems = [
    {
      value: WITH_RX,
      label: getLabel("products.selectRxAble.contactLens.withRx")
    },
    {
      value: WITHOUT_RX,
      label: getLabel("products.selectRxAble.contactLens.withoutRx")
    }
  ];
  const onRxRadioChange = React.useCallback(
    (rxToggle2) => {
      actions.updateRxToggleSelection(rxToggle2);
    },
    [actions]
  );
  return /* @__PURE__ */ React.createElement(
    CLRxableSelect,
    {
      items: radioButtonItems,
      onChange: onRxRadioChange,
      selectedValue: rxToggle,
      className
    }
  );
};
export {
  CLRxableSelectContainer
};
//# sourceMappingURL=CLRxableSelectContainer.js.map
